import Vue from 'vue';
// import "./models/Task";
// import TaskForm from "./components/TaskForm";
// import TaskTable from "./components/TaskTable";
// Vue.component('task-table', TaskTable);
// Vue.component('task-form', TaskForm);
import TasksModal from './components/TasksModal';
import RemindersModal from './components/RemindersModal';

Vue.component('reminders-modal', RemindersModal);
Vue.component('tasks-modal', TasksModal);

export { TasksModal, RemindersModal };
